export default "__VITE_ASSET__BMOIt5Yn__"